/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from 'react'
import { useRequest } from '../../hooks/UseRequest'
import Loading from '../../components/Loading'
import { useSelector } from 'react-redux'
import { selectModules } from '../../redux/moduleSlice'
import DashletTooltip from '../../components/elements/DashletTooltip'
import NoRecord from '../../components/elements/NoRecord'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRefresh, faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import { selectDropdownOptions } from '../../redux/dropdownSlice'
import { useLocation } from 'react-router-dom'
import { FormatISODate } from '../../helpers/formatting'
import ViewSensitivePiiButtons from "../../components/ViewSensitivePiiButtons";

export default function LeadSignatureDashlet({ customerId }) {
  const requests = useRequest()
  const requesting = useRef(false)
  const [row, setRow] = useState([])
  const [loaded, setLoaded] = useState(false)
  const [module, setModule] = useState()
  const modules = useSelector(selectModules)
  const dropdownOptions = useSelector(selectDropdownOptions)
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search);

  useEffect(() => {
    if (!requesting.current && row.length === 0) {
      getLeadSignatures()
    }
  }, [customerId])

  const getLeadSignatures = async () => {
    setLoaded(false)
    requesting.current = true
    const leadGuid = queryParams.get('lead');
    if (leadGuid) {
      requests.setEndpoint(`${process.env.REACT_APP_API_DOMAIN}/manual_verification/${customerId}/lead/${leadGuid}/lead_signatures`)
    } else {
      requests.setEndpoint(`${process.env.REACT_APP_API_DOMAIN}/manual_verification/${customerId}/lead_signatures`)
    }
    try {
      const response = await requests.get()
      setRow(response.data.data)
      const m = modules.data.find((e) => e.code_key === 'lead_signature')
      setModule(m)
      setLoaded(true)
    } catch (error) {
      setLoaded(true)
    }
  }

  const renderHeader = (column_name, customize_label = false) => {
    if (customize_label) {
      return column_name;
    }
    const data = module.module_fields.find(
      (header) => header.column_name === column_name
    )
    if (data && !data.helper_text) {
      return data?.label_name
    }
    return <DashletTooltip columnName={data?.label_name} tooltipText={data?.helper_text} />
  }

  const getToolTipText = (item) => {
    // Get all keys from the item object
    const keys = Object.keys(item);

    // Filter keys that start with 'is_', and map them to their values
    const filteredValues = keys.filter((key) => key.startsWith('is_')).map((key) => `${key}: ${item[key] ? 'True' : 'False'}`);

    // Join the values into a string and return it
    return filteredValues.join('\n');
  }

  return (
    <div className="message is-white lox-dashlet-detail">
      <div className="message-header has-background-primary has-text-white lox-dashlet-detail__title py-0">
        <p className="is-size-4">Signatures</p>
        <p className="is-size-4">
          <span
            className="is-clickable"
            onClick={() => getLeadSignatures()}
          >
            <FontAwesomeIcon icon={faRefresh} className={`${!loaded ? 'fa-pulse' : ''}`} />
          </span>
        </p>
      </div>
      <div className="message-body py-0 px-0" style={{ lineHeight: 1.40 }}>
        {loaded && row && (
          row?.map((item, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <React.Fragment key={index}>
              {index > 0 && <div className="divider m-0 mx-1"></div>}
              <div className="columns m-0">
                <p className="column lox-dashlet-detail__item__label is-size-8">
                  {FormatISODate(item?.updated_at)}
                </p>
                <p className="column lox-dashlet-detail__item__label is-size-8 pl-1" style={{ minWidth: "190px" }}>
                  {dropdownOptions.find((x) => x?.id === item?.validation_status_dropdown_option_id)?.name}
                  {item?.is_discount_applied == 1 && (
                    <>
                      <br />
                      <small className="tag lox-banner-tags lox-no-border has-tooltip-arrow has-tooltip-multiline has-tooltip-bottom has-tooltip-primary is-danger">Signed with ACH APR Discount</small>
                    </>
                  )}
                </p>
                <p className="column lox-dashlet-detail__item__label is-size-8 pl-1" style={{ minWidth: "90px" }}>
                  {item?.validation_status_dropdown_option_id == dropdownOptions.find((x) => x?.code_key === 'validation_status_valid')?.id && (
                    <ViewSensitivePiiButtons customerId={item?.customer_id} documentId={item?.document_id} type={'loan_agreement'} />
                  )}
                </p>
                <p className="column lox-dashlet-detail__item__label is-size-8 pl-1">
                  <span
                    className={`lox-no-border lox-tooltip-moveable has-tooltip-arrow has-tooltip-multiline has-tooltip-bottom has-tooltip-primary has-text-weight-normal is-clickable`}
                    data-tooltip={getToolTipText(item)}
                  >
                    <FontAwesomeIcon icon={faInfoCircle} className="pl-1 has-text-link" style={{ paddingBottom: '.15rem !important' }} />
                  </span>
                </p>
              </div>
            </React.Fragment>
          ))
        )}
        {!loaded && <Loading />}
        {loaded && row.length === 0 && <NoRecord />}
      </div>
    </div>
  )
}
